module.exports = __webpack_public_path__ + "img/logo.1018d482.svg";